<div style="display:inline-block;height:100%;">
  <canvas baseChart
          [plugins]="barChartPlugins"
          [type]="barChartType"
          [legend]="barChartLegend"
          [labels]="barChartLabels"
          [data]="barChartData"
          [options]="barChartOptions"
          style="height:270px; width:400px;">
  </canvas>
</div>
